import { isEmpty } from "@pathwright/ux/src/components/texteditor/utils"

export type CoverPageBlankSlateKind =
  | "offer"
  | "pitch"
  | "preview"
  | "overview"
  | "contributors"
  | "categories"

export function getCoverPageContentGaps({
  shortDescription,
  description,
  hasPreviewableSteps,
  offers,
  contributors,
  categories
}: {
  shortDescription?: string | null
  description?: string | null
  hasPreviewableSteps: boolean
  offers: readonly unknown[]
  contributors: readonly unknown[]
  categories: readonly unknown[]
}): Record<CoverPageBlankSlateKind, boolean> {
  return {
    offer: offers.length === 0,
    pitch: !shortDescription?.trim(),
    preview: !hasPreviewableSteps,
    overview: isEmpty(description),
    contributors: contributors.length === 0,
    categories: categories.length === 0
  }
}
